// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"141":"c6a72685","173":"09d6d0b0","290":"a53f06b8","415":"ba161ac6","521":"b96c43c8","739":"3142a466","924":"48cc2cab","978":"bc241cb6"}[chunkId] + ".chunk.css";
};